import { render, staticRenderFns } from "./EditRetailer.vue?vue&type=template&id=2736a038&scoped=true"
import script from "./EditRetailer.vue?vue&type=script&lang=js"
export * from "./EditRetailer.vue?vue&type=script&lang=js"
import style0 from "./EditRetailer.vue?vue&type=style&index=0&id=2736a038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2736a038",
  null
  
)

export default component.exports